import { createVNode as o, mergeProps as e } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ApplicationFilledStandard.js";
import n from "../components/PfIcon.js";
const t = (r, a) => {
  const i = {
    ...r,
    ...a.attrs
  };
  return o(n, e(i, {
    icon: l
  }), null);
};
t.displayName = "ApplicationFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
